import ProjectApi from "Api/ProjectApi/ProjectApi";
import { MyLoader } from "Components/MyLoader/MyLoader";
import {
  errorNotification,
  successNotification,
} from "Components/MyNotification";
import { defaultSettings } from "css/defaultAntStyles";
import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router";

export const BlankInfoPage = () => {
  const isDark = defaultSettings.navTheme === "realDark";
  const [isLoading, setIsLoading] = useState(true);
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const emailToken = searchParams.get("emailToken");
  const blankId = searchParams.get("blankId");
  const isSuccess = pathname.endsWith("/success");

  useEffect(() => {
    if (!emailToken || !blankId) {
      setIsLoading(false);
    }
    const fetchData = async () => {
      if (isSuccess) {
        try {
          const result = await ProjectApi.sendBlankDone({
            emailToken,
            blankId,
          });
          if (result.status === "fail") {
            errorNotification(result.message);
            return;
          }
          if (result.status === "success") {
            successNotification("Підтверджено нарахування");
            return;
          }
        } catch (err) {
          errorNotification(err.message);
        } finally {
          setIsLoading(false);
        }
      }
    };
    fetchData();
  }, [emailToken, blankId, isSuccess]);

  if (isLoading) {
    return <MyLoader isFull={true} />;
  }
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: isDark ? "#141414" : "#ffffff",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",

          fontWeight: 700,
          fontSize: 22,
          lineHeight: 1,

          padding: "10px 22px",
          border: `3px solid ${defaultSettings.colorPrimary}`,
          borderRadius: 10,

          color: defaultSettings.colorPrimary,
          letterSpacing: 0.5,
        }}
      >
        Закрийте цю сторінку
      </span>
    </div>
  );
};
